document.addEventListener('DOMContentLoaded', () => {
  const builders = document.querySelectorAll('[data-garnkit-builder]');

  builders.forEach((builder) => {
    const dataEl = builder.querySelector('[data-garnkit-json]');
    const sizesEl = builder.querySelector('[data-garnkit-sizes]');
    const linesEl = builder.querySelector('[data-garnkit-lines]');
    const addButton = builder.querySelector('[data-garnkit-add]');
    const errorEl = builder.querySelector('[data-garnkit-error]');
    const totalPriceEl = builder.querySelector('[data-garnkit-total-price]');

    if (!dataEl || !sizesEl || !linesEl || !addButton) return;

    const data = JSON.parse(dataEl.textContent);

    const sizeNamesFromVariants = data.sizeOptions || [];
    const sizeNamesFromJson = Object.keys(data.sizes || {});

  const sizeNames = sizeNamesFromVariants.length
  ? sizeNamesFromVariants.filter((size) => {
      return Object.prototype.hasOwnProperty.call(data.sizes || {}, size);
    })
  : sizeNamesFromJson;

let selectedSize = sizeNames[0];
let selectedVariants = {};
let customQuantities = {};
let isAdding = false;

    function resetButtonText() {
      if (!isAdding) {
        addButton.textContent = 'Læg garn i kurv';
      }
    }

    function showError(message) {
      if (!errorEl) return;

      errorEl.textContent = message;
      errorEl.hidden = false;
    }

    function clearError() {
      if (!errorEl) return;

      errorEl.textContent = '';
      errorEl.hidden = true;
    }

    function isRecipeProduct(product) {
  return product?.variants?.length === 1;
}

function getEmptySelectLabel(product) {
  return isRecipeProduct(product) ? 'Vælg opskrift' : 'Vælg farve';
}

function getVariantLabel(variant, product) {
  if (!variant) return getEmptySelectLabel(product);

  if (variant.title === 'Default Title') {
    return product.title;
  }

  return variant.title;
}

function getColorFunctionSortValue(product) {
  const suffix = String(product.titleSuffix || '').toLowerCase();

  if (suffix.includes('bundfarve')) return 1;

  if (
    suffix.includes('mønsterfarve a') ||
    suffix.includes('monsterfarve a') ||
    suffix.includes('mønster fv. a') ||
    suffix.includes('monster fv. a') ||
    suffix.includes('fv. a')
  ) {
    return 2;
  }

  if (
    suffix.includes('mønsterfarve b') ||
    suffix.includes('monsterfarve b') ||
    suffix.includes('mønster fv. b') ||
    suffix.includes('monster fv. b') ||
    suffix.includes('fv. b')
  ) {
    return 3;
  }

  return 99;
}

function getProductsForRender() {
  return data.products
    .map((product, productIndex) => {
      return {
        product,
        productIndex,
        sortValue: getColorFunctionSortValue(product)
      };
    })
    .sort((a, b) => {
      if (a.sortValue !== b.sortValue) {
        return a.sortValue - b.sortValue;
      }

      return a.productIndex - b.productIndex;
    });
}

    function getQuantities() {
      return data.sizes[selectedSize] || [];
    }
    function getRecommendedQuantity(index) {
  const quantities = getQuantities();
  return Number(quantities[index] || 0);
}

function getSelectedQuantity(index) {
  return Number(customQuantities[index] || getRecommendedQuantity(index));
}

function resetCustomQuantities() {
  customQuantities = {};
}

    function variantHasEnoughStock(variant, quantity) {
      const tracksInventory = Boolean(variant.inventory_management);
      const deniesOverselling = variant.inventory_policy !== 'continue';
      const notEnoughStock =
        tracksInventory &&
        deniesOverselling &&
        Number(variant.inventory_quantity) < Number(quantity);

      return variant.available && !notEnoughStock;
    }

    function autoSelectSingleVariantProducts() {
      const quantities = getQuantities();

      data.products.forEach((product, index) => {
        if (!product.variants || product.variants.length !== 1) return;

        const variant = product.variants[0];
        const quantity = getSelectedQuantity(index);

        if (variantHasEnoughStock(variant, quantity)) {
          selectedVariants[index] = Number(variant.id);
        } else {
          delete selectedVariants[index];
        }
      });
    }

    function removeInvalidSelectedVariants() {
      const quantities = getQuantities();

      data.products.forEach((product, index) => {
        const selectedVariantId = selectedVariants[index];
        if (!selectedVariantId) return;

        const selectedVariant = product.variants.find((variant) => {
          return Number(variant.id) === Number(selectedVariantId);
        });

        const quantity = getSelectedQuantity(index);

        if (!selectedVariant || !variantHasEnoughStock(selectedVariant, quantity)) {
          delete selectedVariants[index];
        }
      });
    }

    function formatMoney(amount) {
      return new Intl.NumberFormat('da-DK', {
        style: 'currency',
        currency: 'DKK'
      }).format(amount / 100);
    }

  function hasAllSelections() {
  return data.products.every((_, index) => {
    return selectedVariants[index] && getSelectedQuantity(index) > 0;
  });
}

function getLowestPossiblePriceForSelectedSize() {
  let sizeTotal = 0;
  let sizeIsValid = true;
  let sizeHasYarn = false;

  data.products.forEach((product, index) => {
    const quantity = getRecommendedQuantity(index);

    if (quantity <= 0) return;

    sizeHasYarn = true;

    const availableVariants = product.variants.filter((variant) => {
      return variantHasEnoughStock(variant, quantity);
    });

    if (!availableVariants.length) {
      sizeIsValid = false;
      return;
    }

    const cheapestVariant = availableVariants.reduce((cheapest, variant) => {
      return Number(variant.price || 0) < Number(cheapest.price || 0)
        ? variant
        : cheapest;
    }, availableVariants[0]);

    sizeTotal += Number(cheapestVariant.price || 0) * quantity;
  });

  if (!sizeIsValid || !sizeHasYarn) return null;

  return sizeTotal;
}

   function updateTotalPrice() {
  if (!totalPriceEl) return;

  if (!hasAllSelections()) {
  const selectedSizePrice = getLowestPossiblePriceForSelectedSize();

  if (selectedSizePrice !== null) {
    totalPriceEl.textContent = `Fra: ${formatMoney(selectedSizePrice)}`;
  } else {
    totalPriceEl.textContent = 'Vælg farver for at se samlet pris';
  }

  return;
}


  const total = data.products.reduce((sum, product, index) => {
    const selectedVariantId = selectedVariants[index];

    const selectedVariant = product.variants.find((variant) => {
      return Number(variant.id) === Number(selectedVariantId);
    });

    if (!selectedVariant) return sum;

   return sum + Number(selectedVariant.price || 0) * getSelectedQuantity(index);
  }, 0);

  totalPriceEl.textContent = formatMoney(total);
}

    function validate() {
     removeInvalidSelectedVariants();

const allSelected = data.products.every((_, index) => {
  return selectedVariants[index] && getSelectedQuantity(index) > 0;
});

      addButton.disabled = !allSelected || isAdding;
      updateTotalPrice();

      return allSelected;
    }

    function renderSizes() {
      sizesEl.innerHTML = '';

      sizeNames.forEach((size) => {
        const button = document.createElement('button');

        button.type = 'button';
        button.className = 'garnkit-size-button';
        button.textContent = size;

        if (size === selectedSize) {
          button.classList.add('is-active');
        }

       button.addEventListener('click', () => {
  selectedSize = size;
  isAdding = false;
  resetCustomQuantities();

  removeInvalidSelectedVariants();
          autoSelectSingleVariantProducts();
          resetButtonText();
          clearError();
          renderSizes();
          renderLines();
          validate();
        });

        sizesEl.appendChild(button);
      });
    }

function renderLines() {
  linesEl.innerHTML = '';

  getProductsForRender().forEach(({ product, productIndex }) => {
    const recommendedQuantity = getRecommendedQuantity(productIndex);
    const quantity = getSelectedQuantity(productIndex);

    if (quantity <= 0) return;

    const selectedVariantId = selectedVariants[productIndex];

        const selectedVariant = product.variants.find((variant) => {
          return Number(variant.id) === Number(selectedVariantId);
        });

        const lineImage = selectedVariant?.image || product.image || '';

        const line = document.createElement('div');
        line.className = 'garnkit-line';

        const imageHtml = lineImage
          ? `<img class="garnkit-line-image" data-line-image src="${lineImage}" alt="${product.title}">`
          : '';

        const optionsHtml = product.variants.map((variant) => {
          const tracksInventory = Boolean(variant.inventory_management);
const deniesOverselling = variant.inventory_policy !== 'continue';
const inventoryQuantity = Number(variant.inventory_quantity || 0);
const requiredQuantity = Number(quantity || 0);

const soldOut =
  !variant.available ||
  (
    tracksInventory &&
    deniesOverselling &&
    inventoryQuantity <= 0
  );

const notEnoughStock =
  !soldOut &&
  tracksInventory &&
  deniesOverselling &&
  inventoryQuantity < requiredQuantity;

const stockLabel = soldOut
  ? 'Udsolgt'
  : notEnoughStock
    ? `Kun ${inventoryQuantity} tilbage`
    : '';

const disabled = soldOut || notEnoughStock;
          const disabledClass = disabled ? 'is-disabled' : '';
          const activeClass =
            Number(selectedVariants[productIndex]) === Number(variant.id)
              ? 'is-active'
              : '';

          const variantLabel = getVariantLabel(variant, product);
          const variantImage = variant.image || product.image || '';
          const title = stockLabel ? `${variantLabel} - ${stockLabel}` : variantLabel;

          return `
            <button
              type="button"
              class="garnkit-color-option ${disabledClass} ${activeClass}"
              data-product-index="${productIndex}"
              data-variant-id="${variant.id}"
              data-variant-title="${variantLabel}"
              data-variant-image="${variantImage}"
              data-disabled="${disabled}"
              ${disabled ? 'disabled' : ''}
              style="background-image: url('${variantImage}')"
              title="${title}"
            >
              ${stockLabel ? `<span class="garnkit-stock-label">${stockLabel}</span>` : ''}
            </button>
          `;
        }).join('');

       const selectedLabelText = selectedVariant
  ? getVariantLabel(selectedVariant, product)
  : getEmptySelectLabel(product);

        line.innerHTML = `
          <div class="garnkit-line-top">
            ${imageHtml}
            <div class="garnkit-line-content">
         <div class="garnkit-line-heading">
  <div class="garnkit-line-title">${product.title}${product.titleSuffix ? ` ${product.titleSuffix}` : ''}</div>

  <span class="garnkit-inline-quantity" data-quantity-control>
    <button type="button" class="garnkit-quantity-button" data-quantity-minus>-</button>
    <span class="garnkit-quantity-value">${quantity} stk.</span>
    <button type="button" class="garnkit-quantity-button" data-quantity-plus>+</button>
  </span>
</div>

              <button type="button" class="garnkit-dropdown-button" data-dropdown-toggle aria-expanded="false">
                <span data-selected-label>${selectedLabelText}</span>
                <span>⌄</span>
              </button>

              <div class="garnkit-color-grid">
                ${optionsHtml}
              </div>
            </div>
          </div>
        `;

        const dropdownButton = line.querySelector('[data-dropdown-toggle]');
        const grid = line.querySelector('.garnkit-color-grid');
        const selectedLabel = line.querySelector('[data-selected-label]');
        const lineImageEl = line.querySelector('[data-line-image]');
        const minusButton = line.querySelector('[data-quantity-minus]');
const plusButton = line.querySelector('[data-quantity-plus]');

if (minusButton && plusButton) {
  minusButton.disabled = quantity <= recommendedQuantity;

  minusButton.addEventListener('click', () => {
    const currentQuantity = getSelectedQuantity(productIndex);
    const nextQuantity = Math.max(recommendedQuantity, currentQuantity - 1);

    customQuantities[productIndex] = nextQuantity;

    removeInvalidSelectedVariants();
    renderLines();
    validate();
  });

  plusButton.addEventListener('click', () => {
    const currentQuantity = getSelectedQuantity(productIndex);

    customQuantities[productIndex] = currentQuantity + 1;

    removeInvalidSelectedVariants();
    renderLines();
    validate();
  });
}

        dropdownButton.addEventListener('click', () => {
          const isOpen = grid.classList.toggle('is-open');

          dropdownButton.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        });

        line.querySelectorAll('.garnkit-color-option').forEach((option) => {
          option.addEventListener('click', () => {
            if (option.dataset.disabled === 'true') return;

            selectedVariants[productIndex] = Number(option.dataset.variantId);
            selectedLabel.textContent = option.dataset.variantTitle;

            if (lineImageEl && option.dataset.variantImage) {
              lineImageEl.src = option.dataset.variantImage;
            }

            line.querySelectorAll('.garnkit-color-option').forEach((el) => {
              el.classList.remove('is-active');
            });

            option.classList.add('is-active');
            grid.classList.remove('is-open');
            dropdownButton.setAttribute('aria-expanded', 'false');

            isAdding = false;

            resetButtonText();
            clearError();
            validate();
          });
        });

        linesEl.appendChild(line);
      });
    }

    async function addToCart() {
      if (!validate()) {
        showError('Vælg farve for alle garnprodukter.');
        return;
      }

      const quantities = getQuantities();

     const items = data.products.map((product, index) => {
  const selectedVariantId = selectedVariants[index];

  const selectedVariant = product.variants.find((variant) => {
    return Number(variant.id) === Number(selectedVariantId);
  });

  return {
    id: selectedVariantId,
    quantity: getSelectedQuantity(index),
    properties: {
      'Garnkit': data.kitTitle || 'Garnkit',
      'Størrelse': selectedSize,
    }
  };
});

      isAdding = true;
      addButton.disabled = true;
      addButton.textContent = 'Tilføjer...';

      clearError();

      try {
        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ items })
        });

        if (!response.ok) {
          const errorData = await response.json().catch(() => null);
          throw new Error(errorData?.description || 'Kunne ikke tilføje til kurven');
        }

        window.location.href = `${window.Shopify.routes.root}cart`;
      } catch (error) {
        console.error(error);

        isAdding = false;
        addButton.disabled = false;
        addButton.textContent = 'Læg garn i kurv';

        showError(error.message || 'Der opstod en fejl. Prøv igen.');
      }
    }

    addButton.addEventListener('click', addToCart);

    autoSelectSingleVariantProducts();
    removeInvalidSelectedVariants();
    renderSizes();
    renderLines();
    validate();
    resetButtonText();
  });
});